import {
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded,
  KeyboardArrowDownRounded,
  KeyboardArrowUpRounded,
} from '@material-ui/icons'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

const iconImages = {
  up: <KeyboardArrowUpRounded className="tool-icon" />,
  down: <KeyboardArrowDownRounded className="tool-icon" />,
  left: <KeyboardArrowLeftRounded className="tool-icon" />,
  right: <KeyboardArrowRightRounded className="tool-icon" />,
}

export default class ToolIcon extends Component {
  render() {
    const { holderRef, name } = this.props
    return (
      <div
        ref={holderRef}
        className="tool-icon-holder"
        id={`icon-holder-${name}`}
      >
        {iconImages[name]}
      </div>
    )
  }
}

ToolIcon.propTypes = {
  holderRef: PropTypes.object,
  name: PropTypes.string,
}
